module.exports = __webpack_public_path__ + "img/FGr_Logistik_Materialwirtschaft_Verbrauchsgüterversorgungstrupp.d51b3e2a.svg";